import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ButtonsColumn, StyledActionButton } from '@/components/Buttons.tsx'
import { createModal, Modal } from '@/components/Modal'
import { BodyM } from '@/components/Text.tsx'
import { useTrackFormProgress } from '@/hooks/useTrackFormProgress'
import { xpertTelNumber } from '@/utils/common.ts'
import { XpertFormStep } from '@/utils/XpertFormSteps'

export const ReferralNotFound = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'referralNotFound',
  })

  const { trackFormError, trackFormInteraction } = useTrackFormProgress(
    XpertFormStep.ReferralNotFound,
  )

  useEffect(() => trackFormError({ error: t('title') }), [])

  const navigate = useNavigate()
  const handleModalClose = useCallback(() => {
    navigate(-1)
    trackFormInteraction({
      action: 'close',
      formFieldName: 'cancel',
    })
  }, [navigate])

  return createModal(
    <Modal title={t('title')} onClose={handleModalClose}>
      <BodyM>
        {t('body', {
          phone: xpertTelNumber,
        })}
      </BodyM>
      <ButtonsColumn>
        <StyledActionButton
          variant="Primary"
          as="a"
          href={`tel:${xpertTelNumber}`}
          id="call-xpert"
          onClick={() => {
            trackFormInteraction({
              action: 'click',
              formFieldName: 'call-xpert',
              formFieldValue: t('actions.call'),
            })
          }}
        >
          {t('actions.call')}
        </StyledActionButton>
        <StyledActionButton
          variant="Secondary"
          onClick={handleModalClose}
          id="cancel"
        >
          {t('actions.cancel')}
        </StyledActionButton>
      </ButtonsColumn>
    </Modal>,
  )
}
